import { lazy, Suspense } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary";
import ProtectedRoute from "./components/ProtectedRoute";

// ─── Lazy-loaded routes ────────────────────────────────────────────────────────
const Home                = lazy(() => import("./pages/Home"));
const About               = lazy(() => import("./pages/About"));
const Events              = lazy(() => import("./pages/Events"));
const Contact             = lazy(() => import("./pages/Contact"));
const Donate              = lazy(() => import("./pages/Donate"));
const SignUp              = lazy(() => import("./pages/SignUp"));
const Admin               = lazy(() => import("./pages/Admin"));
const KnowMore            = lazy(() => import("./components/knowmore"));
const Needhelp            = lazy(() => import("./components/Needhelp"));
const TermsAndPrivacyPolicy = lazy(() => import("./components/TermsAndPrivacyPolicy"));
const AdminDashboard      = lazy(() => import("./pages/AdminDashboard"));
const Members             = lazy(() => import("./components/Members"));
const Collection          = lazy(() => import("./components/Collection"));
const Report              = lazy(() => import("./components/Report"));
const Verification        = lazy(() => import("./components/Verification"));
const Mails               = lazy(() => import("./components/Mails"));
const Theme               = lazy(() => import("./components/Theme"));
const Dashboard           = lazy(() => import("./components/Dashboard"));
const WAM                 = lazy(() => import("./components/WAM"));
const MemberAgreementForm = lazy(() => import("./components/MemberAgreementForm"));
const SadqaBoxForm        = lazy(() => import("./components/SadqaBoxForm"));
const VolunteerAgreementForm = lazy(() => import("./components/VolunteerAgreementForm"));

// ─── Suspense fallback ─────────────────────────────────────────────────────────
function PageLoader() {
  return (
    <div style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100vh",
      flexDirection: "column",
      gap: "16px",
      fontFamily: "system-ui, sans-serif",
      background: "#f9f9f9",
    }}>
      <div style={{
        width: "40px",
        height: "40px",
        border: "4px solid #eee",
        borderTop: "4px solid #162f06",
        borderRadius: "50%",
        animation: "spin 0.8s linear infinite",
      }} />
      <p style={{ color: "#162f06", fontWeight: 600, margin: 0, fontSize: "14px" }}>
        Loading...
      </p>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route exact path="/"                      element={<Home />} />
            <Route exact path="/about"                 element={<About />} />
            <Route exact path="/event"                 element={<Events />} />
            <Route exact path="/TermsAndPrivacyPolicy" element={<TermsAndPrivacyPolicy />} />
            <Route exact path="/contact"               element={<Contact />} />
            <Route exact path="/donate"                element={<Donate />} />
            <Route exact path="/signup"                element={<SignUp />} />
            <Route exact path="/admin"                 element={<Admin />} />
            <Route exact path="/needhelp"              element={<Needhelp />} />
            <Route exact path="/wam"                   element={<WAM />} />
            <Route exact path="/new"                   element={<KnowMore />} />
            <Route path="/knowmore"                    element={<KnowMore />} />
            <Route path="/members"                     element={<Members />} />
            <Route path="/collection"                  element={<Collection />} />
            <Route path="/report"                      element={<Report />} />
            <Route path="/verification"                element={<Verification />} />
            <Route path="/mails"                       element={<Mails />} />
            <Route path="/theme"                       element={<Theme />} />
            <Route path="/dashboard"                   element={<Dashboard />} />
            <Route path="/member-agreement"            element={<MemberAgreementForm />} />
            <Route path="/sadqa-box"                   element={<SadqaBoxForm />} />
            <Route path="/volunteer-agreement"         element={<VolunteerAgreementForm />} />
            <Route
              path="/admindashboard"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route exact path="*" element={<Navigate to={"/"} />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
